import { withInstall } from '@jdesign-vue/utils'

import Backtop from './src/backtop.vue'

export const JdBacktop = withInstall(Backtop)
export default JdBacktop

export * from './src/backtop'
export type { BacktopInstance } from './src/instance'
